//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

// The minimum height for the YouTube logo according to their branding guidelines is 20px.
// Since the logo is wider than it is tall, we need to set a size of 27px in order for the
// height to be at least 20px.
// https://www.youtube.com/howyoutubeworks/resources/brand-resources/#logos-icons-and-colors
export const YOUTUBE_ICON_MIN_SIZE = 27;
